import { supabase } from "@/integrations/supabase/client";
import { getSessionId } from "@/lib/session";
import type { AppMode } from "@/lib/mode";
import { t as translate, type Lang } from "@/lib/i18n";

const MEDIA_KEY: Record<string, string> = {
  CDMX: "geo_media_cdmx",
  Miami: "geo_media_miami",
  "New York": "geo_media_ny",
  "Bogotá": "geo_media_bog",
  Madrid: "geo_media_mad",
};
const BETTING_KEY: Record<string, string> = {
  CDMX: "geo_betting_cdmx",
  Miami: "geo_betting_miami",
  "New York": "geo_betting_ny",
  "Bogotá": "geo_betting_bog",
  Madrid: "geo_betting_mad",
};

export interface GeoCopy {
  city: string;
  message: string;
  isBetting: boolean;
}

export async function resolveUserCity(): Promise<string> {
  if (typeof window === "undefined") return "";
  try {
    const sid = getSessionId();
    const { data } = await supabase
      .from("user_profiles")
      .select("city")
      .eq("session_id", sid)
      .maybeSingle();
    return (data?.city as string | undefined) || "";
  } catch {
    return "";
  }
}

export function buildGeoCopy(city: string, mode: AppMode, lang: Lang = "ES"): GeoCopy {
  const isBetting = mode === "betting";
  const map = isBetting ? BETTING_KEY : MEDIA_KEY;
  const cityLabel = city || (lang === "EN" ? "your city" : lang === "PT" ? "sua cidade" : "tu ciudad");
  const key = map[city];
  const fallbackKey = isBetting ? "geo_betting_default" : "geo_media_default";
  const message = key ? translate(key, lang) : translate(fallbackKey, lang, { city: cityLabel });
  return { city: cityLabel, message, isBetting };
}